export enum AlertTypeEnum {
    Warning = 1,
    Error = 2,
    Success = 3,
    Info = 4
}
